// Define listItems after the DOM has loaded
// document.addEventListener('DOMContentLoaded', function() {
//     let listItems = document.querySelectorAll('.title');
  
//     let options = {
//       rootMargin: '-10%',
//       threshold: 0.0,
//     };
    
//     let observer = new IntersectionObserver(showItem, options);
    
//     function showItem(entries) {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           let letters = [...entry.target.querySelectorAll('span')];
//           letters.forEach((letter, idx) => {
//             setTimeout(() => {
//               letter.classList.add('active');
//             }, idx * 40);
//           });
//           entry.target.children[0].classList.add('active');
//         }
//       });
//     }
    
//     listItems.forEach((item) => {
//       let newString = '';
//       let itemText = item.children[0].innerText.split('');
//       itemText.forEach((letter) => {
//         newString += letter === ''
//           ? `<span class='gap'></span>`
//           : `<span>${letter}</span>`;
//       });
    
//       item.innerHTML = newString;
//       observer.observe(item);
//     });
//   });
document.addEventListener('DOMContentLoaded', function () {
    let listItems = document.querySelectorAll('.title');

    let options = {
        root: null, // Set to null to use the viewport as the root
        rootMargin: '0px', // Adjust as needed
        threshold: 0.1, // Adjust as needed
    };

    let observer = new IntersectionObserver(showItem, options);

    function showItem(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let letters = [...entry.target.querySelectorAll('span')];
                letters.forEach((letter, idx) => {
                    setTimeout(() => {
                        letter.classList.add('active');
                    }, idx * 40);
                });
                entry.target.children[0].classList.add('active');
            }
        });
    }

    listItems.forEach((item) => {
        let newString = '';
        let itemText = item.children[0].innerText.split('');
        itemText.forEach((letter) => {
            newString += letter === ''
                ? `<span class='gap'></span>`
                : `<span>${letter}</span>`;
        });

        item.innerHTML = newString;
        observer.observe(item);
    });
});


  // ---------------------------------------------------------------------------------------------------

function sizeGuide(){
  const sizeContainer = document.querySelector(".size-guide-popup");
      sizeContainer.classList.toggle("open");
}

document.addEventListener("DOMContentLoaded", function () {
    const stocklistLink = document.querySelector(".stocklist");
    const popup = document.getElementById("popup");
    const popupContent = document.querySelector(".popup-content");

    stocklistLink.addEventListener("click", function (event) {
        event.preventDefault();
        popup.style.display = "block";
    });

    // Close the popup when clicking outside of it
    document.addEventListener("click", function (event) {
        if (!popupContent.contains(event.target) && event.target !== stocklistLink) {
            popup.style.display = "none";
        }
    });
});

